import React, {useEffect, useState} from "react";
import {Fade, ImageList, ImageListItem} from "@mui/material";
import MemoItem from "../components/Item";
import {getCols} from "./ItemList";

function SimpleItemList({
                            alwaysShow,
                            handlePreload,
                            items,
                            handleToggle,
                            sort,
                            preload,
                            currentItem,
                            recentItems,
                            currentOverlayId,
                            setCurrentOverlayId, rows
                        }) {
    const [cols, setCols] = useState(getCols(window.innerHeight, window.innerWidth));
    const count = cols * rows;

    useEffect(() => {
        const detectSize = () => {
            setCols(getCols(window.innerHeight, window.innerWidth))
        }
        window.addEventListener('resize', detectSize)
        return () => {
            window.removeEventListener('resize', detectSize)
        }
    }, []);

    return (
        <>
            <Fade in={true}>
                <ImageList className={"SimpleItemList"} onTouchStart={() => {
                }}
                           sx={{paddingBottom: '4em'}}
                           cols={cols} gap={2}>
                    {items.length === 0 ? ([...Array(count)].map((_, index) =>
                            <ImageListItem key={index}>
                                <div className={"CustomShimmer ImageSize"} style={{width: "100%"}}/>
                            </ImageListItem>))
                        :
                        items.slice(0, count).map((item, i) => {
                            return <MemoItem
                                isClicked={recentItems.includes(item.itemId)}
                                isCurrentItem={currentItem?.itemId === item.itemId}
                                alwaysShow={alwaysShow}
                                preload={preload?.id === item.itemId ? preload : null}
                                handlePreLoad={handlePreload} key={item.itemId}
                                item={item} handleToggle={handleToggle} setLoading={() => {
                            }}
                                isFirst={i === 0}
                                isCurrentOverlayId={currentOverlayId === item.itemId}
                                setCurrentOverlayId={setCurrentOverlayId} sort={sort}/>
                        })
                    }
                </ImageList>
            </Fade>
        </>
    )
}

export default SimpleItemList;